<template>
    <div class="Complaints messageBoard">
        <van-image
        class="Complaints-img"
        :src="img"
        />
        <div class="Complaints-box">
            <div class="Complaints-box-Content">
                <van-field 
                v-model="value" 
                type="textarea"
                :autosize="{ minHeight: 200 }"
                placeholder="在这里您可以为我们点赞、吐槽、提问、建议， 我们讲及时回复，您的留言，是我们前进的动力。" 
                />
            </div>
            <div class="Complaints-btn">
                <van-button round block type="info" native-type="submit" v-touch:tap="submit">提交</van-button>
            </div>
        </div>
        
    </div>
</template>
<script>
import { Field ,Button ,Toast } from 'vant';
// import http from '@js/http-ww.js'
import http from '@js/http-zyz.js'
import {getAllSubmitUrl} from '@culturalRelicsUrl';
export default {
    data(){
        return {
            img: require('../../lib/image/complaint/45.png'),
            value:""
        }
    },
    created() {
        // this.submit();
    },
    methods: {
        submit(){
            var data = {
                text : this.value,
                username: this.getUserInfo.userName,
                phone: this.getUserInfo.phone,
            }
            http.post(getAllSubmitUrl, data)
            .then(res=>{
                if(res){
                    this.$toast.success({ 
                        message: "提交成功",
                        onClose:()=>{
                            this.$router.go(-1);
                        }
                    });
                }
            })
        }
    },
    computed: {
        getUserInfo(){
            let info = this.$store.state.userInfo.info || {};
            return info;
        },
    },
    components: {
        [Field.name]: Field,
        [Button.name]: Button,
        [Toast.name]: Toast,
    }
}   
</script>
<style lang="less" scoped>
   .Complaints{
        background:#EFF0FA!important;
        .Complaints-img{
            height: 236px;
            width: 100%;
        }
        .Complaints-box{
            position: relative;
            top:-18px;
            padding: 0 10px;
            .Complaints-box-Content{
                background:rgba(255,255,255,1);
                box-shadow:0px 1px 8px 0px rgba(212,206,218,0.5);
                border-radius:5px;
                padding:5px;
                color: #727980;
                .f-size-20{
                    font-size: 20px;
                }
                .f-size-14{
                    font-size: 14px;
                    font-weight:400;
                    line-height:20px;
                }
            }
            .Complaints-btn{
                padding: 30px 12px;
            }
        }
   }
</style>